import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../constants/config";
import * as keyCodes from "../../../constants/keyCodes";
import * as resources from "../../../constants/resources";
import * as rcc from "../../../constants/rcc";
import * as validationHelper from "../../../helpers/validationHelper";
import * as colorHelper from "../../../helpers/colorHelper";

import imgClose from "../../../resources/img/svgicons/close-black.svg";
import imgWarning from "../../../resources/img/svgicons/warning.svg";
import imgCritical from "../../../resources/img/svgicons/error.svg";

import NumericKeyboardInput from "../NumericKeyboardInput";

export default class CanisterLevelsModalLight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeWindow: 0,
            currentLevelOverride: null,
            maxDispenseLevelOverride: null,
            canister: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentLevelOverride === null && this.state.currentLevelOverride !== null) {
            window.jQuery("#current-level-input").focus();
        }
        if (prevState.maxDispenseLevelOverride === null && this.state.maxDispenseLevelOverride !== null) {
            window.jQuery("#max-dispense-level-input").focus();
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.canister !== null) {
            let newCanister = nextProps.canisterList.find((canister) => canister.id === prevState.canister.id);

            if (newCanister !== undefined) {
                return {
                    canister: newCanister
                };
            }
        }

        return null;
    }

    setMaxDispenseLevelState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({maxDispenseLevelOverride: value});
        }
    };

    setCurrentLevelOverrideState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({
                currentLevelOverride: value
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleCloseDetailModalClick = () => {
        this.setState({
            canister: null,
            currentLevelOverride: null,
            maxDispenseLevelOverride: null
        });
    };

    handleCanisterClick = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister !== null && canister.colorant !== null) {
            this.props.getCanisterImage(canister);

            this.setState({
                canister: canister
            });
        }
    };

    handleCurrentLevelClick = () => {
        if (this.state.maxDispenseLevelOverride !== null) {
            this.setState({
                maxDispenseLevelOverride: null,
                currentLevelOverride: ""
            });
        } else {
            this.setState({currentLevelOverride: ""});
        }
    };

    handleMaxDispenseLevelClick = () => {
        if (this.state.currentLevelOverride !== null) {
            this.setState({
                currentLevelOverride: null,
                maxDispenseLevelOverride: ""
            });
        } else {
            this.setState({maxDispenseLevelOverride: ""});
        }
    };

    handleCurrentLevelChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                currentLevelOverride: event.target.value
            });
        }
    };

    handleCurrentLevelKeyDown = (event) => {
        if (event.keyCode === keyCodes.ENTER) {
            this.confirmCurrentLevel(this.state.currentLevelOverride);
        }
    };

    handleCurrentLevelBlur = () => {
        this.confirmCurrentLevel(this.state.currentLevelOverride);
    };

    handleMaxDispenseLevelChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                maxDispenseLevelOverride: event.target.value
            });
        }
    };

    handleMaxDispenseLevelKeyDown = (event) => {
        if (event.keyCode === keyCodes.ENTER) {
            this.confirmMaxDispenseLevel(this.state.maxDispenseLevelOverride);
        }
    };

    handleMaxDispenseLevelBlur = () => {
        if (!this.props.virtualKeyboardEnabled) {
            this.confirmMaxDispenseLevel(this.state.maxDispenseLevelOverride);
        }
    };

    handleStartCanisterRefillClick = () => {
        if (this.props.machine.isConnected) {
            this.props.startCanisterRefill(this.state.canister.id);
            this.props.closeModal();
        }
    };

    handleChangeActiveWindowForward = () => {
        this.setState({activeWindow: this.state.activeWindow + 1});
    };

    handleChangeActiveWindowBackward = () => {
        this.setState({activeWindow: this.state.activeWindow - 1});
    };

    confirmCurrentLevel = (valueText) => {
        let value = null;

        if (typeof valueText === "string" && valueText !== "") {
            value = Number(validationHelper.formatDecimal(valueText));
        }

        if (typeof valueText === "number") {
            value = valueText;
        }

        this.setState({currentLevelOverride: null});

        if (value !== null && value !== this.state.canister.currentLevel) {
            this.props.confirmCanisterRefill(
                this.state.canister.id,
                value,
                false,
                false,
                rcc.RCC_REFILL_MANUAL_CORRECTION
            );
        }
    };

    confirmMaxDispenseLevel = (valueText) => {
        let value = null;

        if (typeof valueText === "string" && valueText !== "") {
            value = Number(validationHelper.formatDecimal(valueText));
        }

        if (typeof valueText === "number") {
            value = valueText;
        }

        this.setState({maxDispenseLevelOverride: null});

        if (value !== null) {
            this.props.setMaxDispenseLevel(this.state.canister.id, value);
        }
    };

    getCanisterById = (id) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.id === id) {
                return canister;
            }
        }

        return null;
    };

    getColorantRgbByCanister = (canister) => {
        if (canister.colorant === null) {
            return config.DEFAULT_RGB;
        }

        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant.name === colorant.name) {
                return colorant.rgb;
            }
        }

        return config.DEFAULT_RGB;
    };

    getCanisterBoxClassName = (canister) => {
        if (canister.currentLevel < canister.minimumLevel) {
            return "canister-level-box critical";
        }

        if (canister.currentLevel < canister.warningLevel) {
            return "canister-level-box warning";
        }

        return "canister-level-box";
    };

    getCanisters = (splitCanisterList) => {
        let canister,
            colorantName,
            colorantRgb,
            level,
            minLevel,
            warningLevel,
            brightness,
            minLevelColor,
            warningLevelColor,
            canisters = [];

        for (canister of splitCanisterList[this.state.activeWindow]) {
            colorantName = "";
            colorantRgb = null;
            if (canister.colorant !== null) {
                colorantName = canister.colorant.name;
                colorantRgb = canister.colorant.rgb;
            }

            if (colorantRgb === null) {
                colorantRgb = this.getColorantRgbByCanister(canister);
            }

            level = canister.currentLevelPercentage();
            minLevel = canister.minimumLevelPercentage();
            warningLevel = canister.warningLevelPercentage();

            brightness = colorHelper.getColorBrightness(colorantRgb);
            minLevelColor = minLevel > level || brightness > 50 ? "#bc0002" : "#fb997b";
            warningLevelColor = warningLevel > level || brightness > 40 ? "#9c9e0f" : "#fbff75";
            canisters.push(
                <div
                    className={this.getCanisterBoxClassName(canister)}
                    key={canister.id}
                    onClick={this.handleCanisterClick}
                    data-id={canister.id}
                >
                    <div className="height-100">
                        <div className="height-100">
                            <div className="progress vertical">
                                <div
                                    className="colorant-actual-level"
                                    style={{bottom: level + "%", borderColor: config.DEFAULT_RGB}}
                                />
                                <div
                                    className="colorant-min-level"
                                    style={{bottom: minLevel + "%", borderColor: minLevelColor}}
                                />
                                <div
                                    className="colorant-warning-level"
                                    style={{bottom: warningLevel + "%", borderColor: warningLevelColor}}
                                />
                                <div
                                    className="progress-bar vertical"
                                    role="progressbar"
                                    aria-valuenow=""
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    style={{height: level + "%", backgroundColor: colorantRgb}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="canister-level-id">{canister.id}</div>
                    <div className="canister-level-name">{colorantName}</div>
                    <div className="canister-level-actual">
                        <Translate value="general.actualLevel" />: {canister.formatCurrentLevel()}
                    </div>
                    <div className="canister-level-size">
                        <Translate value="general.maximum" />: {canister.capacity}
                    </div>
                    <img src={imgWarning} className="canister-low-level-icon warning" alt="icon" />
                    <img src={imgCritical} className="canister-low-level-icon critical" alt="icon" />
                </div>
            );
        }

        return canisters;
    };

    getBackButton = (splitCanisterList) => {
        if (splitCanisterList.length > 1) {
            if (this.state.activeWindow > 0) {
                return (
                    <button className="btn btn-danger" onClick={this.handleChangeActiveWindowBackward}>
                        <div className="pull-left orders-arrow">
                            <span className="glyphicon glyphicon-menu-left" />
                        </div>
                    </button>
                );
            }

            return (
                <button className="btn btn-danger disabled">
                    <div className="pull-left orders-arrow">
                        <span className="glyphicon glyphicon-menu-left" />
                    </div>
                </button>
            );
        }
        return "";
    };

    getForwardButton = (splitCanisterList) => {
        if (splitCanisterList.length > 1) {
            if (this.state.activeWindow < splitCanisterList.length - 1) {
                return (
                    <button className="btn btn-danger" onClick={this.handleChangeActiveWindowForward}>
                        <div className="pull-left orders-arrow">
                            <span className="glyphicon glyphicon-menu-right" />
                        </div>{" "}
                    </button>
                );
            }

            return (
                <button className="btn btn-danger disabled">
                    <div className="pull-left orders-arrow">
                        <span className="glyphicon glyphicon-menu-right" />
                    </div>{" "}
                </button>
            );
        }
        return "";
    };

    getCanisterImage = () => {
        let canisterImage = window.imageStore.getMachineCanister();

        if (this.state.canister === null || canisterImage === null) {
            return "";
        }

        return (
            <div className="canister-image">
                <img alt="" src={"data:" + canisterImage.type + ";base64," + canisterImage.img} />
            </div>
        );
    };

    getCanisterBar = (colorantRgb) => {
        let level = this.state.canister.currentLevelPercentage();
        let minLevel = this.state.canister.minimumLevelPercentage();
        let warningLevel = this.state.canister.warningLevelPercentage();

        let intensity = colorHelper.getColorIntensity(colorantRgb);
        let minLevelColor = minLevel > level || intensity > config.DEFAULT_INTENSITY ? "#bc0002" : "#fb997b";
        let warningLevelColor = warningLevel > level || intensity > config.DEFAULT_INTENSITY ? "#9c9e0f" : "#fbff75";

        let canisterDetailClass = "canister-detail-progress";

        if (this.state.canister === null || window.imageStore.getMachineCanister() === null) {
            canisterDetailClass += " wide-content";
        }

        return (
            <div className={canisterDetailClass}>
                <div className="progress vertical">
                    <div className="colorant-min-level" style={{bottom: minLevel + "%", borderColor: minLevelColor}} />
                    <div
                        className="colorant-warning-level"
                        style={{bottom: warningLevel + "%", borderColor: warningLevelColor}}
                    />
                    <div
                        className="progress-bar vertical"
                        role="progressbar"
                        aria-valuenow=""
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{height: level + "%", backgroundColor: colorantRgb}}
                    />
                </div>
                <div className="canister-level-id color-primary">{this.state.canister.id}</div>
            </div>
        );
    };

    getCanisterCurrentLevel = () => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_SET_CANISTER_LEVEL)) {
            return (
                <div className="col-xs-8 summary-text">
                    <span>
                        {this.state.canister.formatCurrentLevel()} {this.props.rccUnit}
                    </span>
                </div>
            );
        }

        if (this.state.currentLevelOverride !== null) {
            return (
                <div className="col-xs-8 summary-text input-with-key">
                    <NumericKeyboardInput
                        type="text"
                        id="current-level-input"
                        value={this.state.currentLevelOverride}
                        onKeyDown={this.handleCurrentLevelKeyDown}
                        onChange={this.handleCurrentLevelChange}
                        onBlur={this.handleCurrentLevelBlur}
                        extended={true}
                        setInputState={this.setCurrentLevelOverrideState}
                    />
                </div>
            );
        }

        return (
            <div className="col-xs-8 summary-text summary-text-edit">
                <span onClick={this.handleCurrentLevelClick} data-level={this.state.canister.currentLevel}>
                    {this.state.canister.formatCurrentLevel()} {this.props.rccUnit}
                </span>
            </div>
        );
    };

    getMaxDispenseLevel = () => {
        if (this.props.loggedUser.canNotRead(resources.FUNCTION_SET_MAX_CANISTER_DISPENSE_AMOUNT)) {
            return "";
        }

        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_SET_MAX_CANISTER_DISPENSE_AMOUNT)) {
            return (
                <div className="col-xs-8 summary-text">
                    <span>
                        {this.state.canister.formatMaxDispenseLevel()} {this.props.rccUnit}
                    </span>
                </div>
            );
        }

        if (this.state.maxDispenseLevelOverride !== null) {
            return (
                <div className="col-xs-8 summary-text input-with-key">
                    <NumericKeyboardInput
                        type="text"
                        id="max-dispense-level-input"
                        value={this.state.maxDispenseLevelOverride}
                        onKeyDown={this.handleMaxDispenseLevelKeyDown}
                        onChange={this.handleMaxDispenseLevelChange}
                        onBlur={this.handleMaxDispenseLevelBlur}
                        extended={true}
                        setInputState={this.setMaxDispenseLevelState}
                    />
                </div>
            );
        }

        return (
            <div className="col-xs-8 summary-text summary-text-edit">
                <span onClick={this.handleMaxDispenseLevelClick} data-level={this.state.canister.maxDispenseLevel}>
                    {this.state.canister.formatMaxDispenseLevel()} {this.props.rccUnit}
                </span>
            </div>
        );
    };

    getMaxDispenseLevelSection = () => {
        if (!this.props.weberSoftware) {
            return "";
        }

        return (
            <React.Fragment>
                <div className="col-xs-4 summary-title">
                    <Translate value="canisterLevel.maxDispenseLevel" />
                </div>
                {this.getMaxDispenseLevel()}
            </React.Fragment>
        );
    };

    getNoCanistersMessage = () => {
        if (this.props.canisterList.length === 0) {
            return (
                <div className="no-available">
                    <Translate value="machineSettings.machineConfigurationNoCanisters" />
                </div>
            );
        }

        return "";
    };

    getCanisterInfo = () => {
        return (
            <div className="canister-detail-info-box">
                <div className="col-xs-4 summary-title">
                    <Translate value="general.canisterId" />
                </div>
                <div className="col-xs-8 summary-text">
                    <span>{this.state.canister.id}</span>
                </div>
                <div className="col-xs-4 summary-title">
                    <Translate value="general.maximum" />
                </div>
                <div className="col-xs-8 summary-text">
                    <span>
                        {this.state.canister.capacity} {this.props.rccUnit}
                    </span>
                </div>
                <div className="col-xs-4 summary-title">
                    <Translate value="general.warning" />
                </div>
                <div className="col-xs-8 summary-text">
                    <span>
                        {this.state.canister.warningLevel} {this.props.rccUnit}
                    </span>
                </div>
                <div className="col-xs-4 summary-title">
                    <Translate value="general.minimum" />
                </div>
                <div className="col-xs-8 summary-text">
                    <span>
                        {this.state.canister.minimumLevel} {this.props.rccUnit}
                    </span>
                </div>
                <div className="col-xs-4 summary-title">
                    <Translate value="general.actualLevel" />
                </div>
                {this.getCanisterCurrentLevel()}
                {this.getMaxDispenseLevelSection()}
            </div>
        );
    };

    getColorantDetailRgbByCanister = () => {
        if (this.state.canister.colorant === null) {
            return config.DEFAULT_RGB;
        }

        let colorant;
        for (colorant of this.props.colorantList) {
            if (this.state.canister.colorant.name === colorant.name) {
                return colorant.rgb;
            }
        }

        return config.DEFAULT_RGB;
    };

    getRefillCanisterButton = () => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_TRIGGER_REFILL_DIALOG)) {
            return "";
        }

        if (!this.props.machine.isConnected || this.props.machine.isBusy) {
            return (
                <button className="btn btn-danger canister-scan-proper disabled">
                    <Translate value="customRedlikeMachine.touchToStartFilling" />
                </button>
            );
        }

        return (
            <button
                className="btn btn-danger canister-scan-proper cursor-pointer"
                onClick={this.handleStartCanisterRefillClick}
            >
                <Translate value="customRedlikeMachine.touchToStartFilling" />
            </button>
        );
    };

    render() {
        if (this.state.canister !== null) {
            let colorantName = "";
            let colorantRgb = null;

            if (this.state.canister.colorant !== null) {
                colorantName = this.state.canister.colorant.name;
                colorantRgb = this.state.canister.colorant.rgb;
            }

            if (colorantRgb === null) {
                colorantRgb = this.getColorantDetailRgbByCanister();
            }

            return (
                <div id="modal" className="set-canister-level canister-detail canister-modal">
                    <header className="color-red">
                        <Translate className="pull-left" value="customRedlikeMachine.canistersLevel" />
                        <div className="colorant-square pull-left" style={{backgroundColor: colorantRgb}} />
                        <div className="color-code">{colorantName}</div>
                        <div className="modal-close" onClick={this.handleCloseDetailModalClick}>
                            <img src={imgClose} className="close-img" alt="close" />
                        </div>
                    </header>
                    <div className="modal-content set-canister-level-content">
                        {this.getCanisterImage()}
                        {this.getCanisterBar(colorantRgb)}
                        {this.getCanisterInfo()}
                        {this.getNoCanistersMessage()}
                    </div>
                    {this.getRefillCanisterButton()}
                </div>
            );
        }

        let splitCanisterList = [],
            numberOfCanisters = 16;
        if (this.props.canisterList.length > numberOfCanisters) {
            for (let i = 0; i < this.props.canisterList.length; i += numberOfCanisters) {
                splitCanisterList.push(this.props.canisterList.slice(i, i + numberOfCanisters));
            }
        } else {
            splitCanisterList.push(this.props.canisterList);
        }

        return (
            <div id="modal" className="set-canister-level canister-modal">
                <header className="color-primary">
                    <Translate value="customRedlikeMachine.canistersLevel" />
                    <div className="modal-close" onClick={this.handleCloseModalClick}>
                        <img src={imgClose} className="close-img" alt="close" />
                    </div>
                </header>
                <div className="modal-content set-canister-level-content">
                    <div className="set-buttons">{this.getBackButton(splitCanisterList)}</div>
                    <div className="set-buttons pull-right">{this.getForwardButton(splitCanisterList)}</div>
                    {this.getCanisters(splitCanisterList)}
                    {this.getNoCanistersMessage()}
                </div>
            </div>
        );
    }
}
